import { combineReducers } from 'redux'
import LoadingReducer from './loading/reducers'
import customizationReducer from './customization/customizationReducer'
import AccountReducer from './account/reducers'
import SellerReducer from './seller/reducers'
import SummaryHeaderReducer from './summary/header/reducers'

const rootReducers = combineReducers({
  loading: LoadingReducer,
  customization: customizationReducer,
  account: AccountReducer,
  seller: SellerReducer,
  summaryHeader: SummaryHeaderReducer,
})

export default rootReducers
